// extracted by mini-css-extract-plugin
export default {"Box":"table-group-contents-module__Box--tIQZG","disabledFooter":"table-group-contents-module__disabledFooter--_J8Zm"};